import React from "react";
import { Stack, Text } from "../../vanilla";
import { Link } from "react-router-dom";
import { ErrorMessageConfig } from "../../utils/constants";

interface ErrorMessageProps {
    errorMessage: ErrorMessageConfig
}

export const ErrorMessage = ({errorMessage}: ErrorMessageProps) => {
    const { errorHeading, message, customLink, includeCustomerCare } = errorMessage

    return (
        <Stack paddingX={['16px', '20px']} paddingY={['20px', '24px']} background={'errorBackground'}>
            {errorHeading && (
                <Text variant="heading1" lineHeight="shorter" color="accent0">
                    {errorHeading}
                </Text>
            )}
            <Text variant="text4" lineHeight="shorter" color="accent0">
                {message}
                {customLink &&
                    <Link to={{ pathname: `${customLink.pathname ?? '/'}`, state: { redirectTo: `${customLink.redirectTo ?? '/'}` } }}>
                        <Text
                            as="span"
                            variant="text4"
                            lineHeight="shorter"
                            color="accent0"
                            textDecoration="underline"
                        >
                            {customLink.text ?? ''}
                        </Text>
                    </Link>
                }
                {includeCustomerCare &&
                    <>
                        {' '}
                        If this is not the first time you have seen this message, please{' '}
                        <Text
                            variant="text4"
                            lineHeight="shorter"
                            color="accent0"
                            as={Link}
                            to="/customer-support/contact-us"
                            textDecoration="underline"
                        >
                            contact our Customer Care team
                        </Text>{' '}
                        for assistance.
                    </>}
            </Text>
        </Stack>
    )
}